import { Redirect, useLocation, useParams } from 'react-router-dom';
import * as BreadcrumbsPrimitive from 'components/breadcrumbs';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { EngageMessageChannel } from 'types/domain';

interface BreadcrumbsProps {
    current: string;
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
    const { current } = props;
    const { accountId } = useCurrentAccount();
    const { pathname, search } = useLocation();
    const { channel } = useParams<{ channel: EngageMessageChannel }>();

    if (!['email', 'sms'].includes(channel)) {
        return <Redirect to={`/accounts/${accountId}/engage`} />;
    }

    return (
        <BreadcrumbsPrimitive.Root className={'mt-2.5'}>
            <BreadcrumbsPrimitive.Crumb to={`/accounts/${accountId}/engage/${channel}`}>
                {channel === 'email' ? 'Emails' : 'Texts'}
            </BreadcrumbsPrimitive.Crumb>
            <BreadcrumbsPrimitive.Crumb
                to={{
                    pathname,
                    search,
                }}
            >
                {current}
            </BreadcrumbsPrimitive.Crumb>
        </BreadcrumbsPrimitive.Root>
    );
};

export default Breadcrumbs;
